import basilBeef from '../../assets/images/carousel/basil-beef-uncropped.png';
import beefSichuan from '../../assets/images/carousel/crazy-beef-sichuan-ncropped.png';
import pepperChicken from '../../assets/images/carousel/pepperchicken-uncropped.png';
import spicyDumplings from '../../assets/images/carousel/spicy-dumplings-uncropped.png';
import seafoodNoodle from '../../assets/images/carousel/seafood-noodle-basket-uncropped.png';
import prawnsCreamy from '../../assets/images/carousel/prawns-creamy-marnier-uncropped.png';
import danDan from '../../assets/images/carousel/dan-danMeinNoodles.png';

const dishes = [
  {
    name: 'BASIL WITH BEEF',
    price: '$14.95',
    image: basilBeef,
  },
  {
    name: 'CRAZY BEEF SICHUAN STYLE',
    price: '$18.95',
    image: beefSichuan,
  },
  {
    name: '3 PEPPER CHICKEN',
    price: '$15.95',
    image: pepperChicken,
  },
  {
    name: 'SPICY DUMPLING',
    price: '$6.50',
    image: spicyDumplings,
  },
  {
    name: 'SEAFOOD IN A NOODLE BASKET',
    price: '$21.95',
    image: seafoodNoodle,
  },
  {
    name: 'PRAWNS WITH CREAMY MARNIER SAUCE',
    price: '$22.95',
    image: prawnsCreamy,
  },
  {
    name: 'DAN-DAN MEIN NOODLE',
    price: '$14.95',
    image: danDan,
  },
];

export default dishes;
